import { message } from 'antd'

const STORAGE_KEY = '@adopets/admin-auth'

export default async function AuthHandler(): Promise<any> {
  window.localStorage.removeItem(STORAGE_KEY);

  message.error('Your session has expired. Please log in');

  setTimeout(() => {
    window.location.reload();
  }, 1000);

  return null;
}
